import { createSelector } from '@ngrx/store';

import { menuFlowImagesState } from '../root';

export const getMenuFlowImagesState = createSelector(menuFlowImagesState, (menuFlowImages) => menuFlowImages);
